module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "theme-form"
    }
  }, [_c('v-breadcrumbs', {
    attrs: {
      "items": [{
          text: 'Dashboard',
          to: {
            path: '/'
          }
        },
        {
          text: 'Ambis Test',
          to: {
            path: '/ambis-test'
          },
          exact: true,
        },
        {
          text: !_vm.$route.query.id ?
            'Tambah Tema Skala' :
            'Ubah Tema Skala',
        } ],
      "divider": "|"
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "header-text font-weight-bold"
  }, [_vm._v("Ambis Test")]), _vm._v(" "), _c('v-card', {
    staticStyle: {}
  }, [_c('v-card-title', [_vm._v("\n            " + _vm._s(!_vm.$route.query.id ? "Tambah" : "Ubah") + " Tema\n            Skala")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card', {
    staticClass: "d-flex",
    attrs: {
      "flat": ""
    }
  }, [_c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "3"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-text', {
    staticClass: "pa-0 my-2"
  }, [_c('v-card', {
    staticClass: "border-bottom-divider rounded-tl pa-0",
    attrs: {
      "flat": ""
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('img', {
    key: _vm.keyimg,
    attrs: {
      "src": _vm.url ?
        _vm.url :
        _vm.data.image && _vm.data.image != '' ?
        _vm.data.image :
        require('@/assets/img/unavailable.png')
    }
  })])])], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-0 my-2"
  }, [_c('v-btn', {
    staticClass: "pa-0 font-weight-bold dark--text",
    attrs: {
      "block": "",
      "color": "white"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.uploader.click()
      }
    }
  }, [_vm._v("\n                            Upload Foto\n                        ")]), _vm._v(" "), _c('input', {
    ref: "uploader",
    staticClass: "d-none",
    attrs: {
      "id": "photo_tema_skala",
      "type": "file",
      "accept": "image/*"
    },
    on: {
      "change": _vm.onFileChange
    }
  })], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "text-caption pa-0 d-flex justify-center mb-5"
  }, [_vm._v("\n                        Rasio thumbnail foto 16:9 (HD)\n                    ")])], 1)], 1), _vm._v(" "), _c('v-col', {
    staticStyle: {
      "border-left": "1px solid #f0f0f0"
    },
    attrs: {
      "cols": "9"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-text', {
    staticClass: "pa-0"
  }, [_c('v-list-item', {
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                                    Nama Tema\n                                ")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "placeholder": "Nama Tema",
      "required": "",
      "outlined": ""
    },
    model: {
      value: (_vm.data.theme_name),
      callback: function($$v) {
        _vm.$set(_vm.data, "theme_name", $$v)
      },
      expression: "data.theme_name"
    }
  })], 1)], 1), _vm._v(" "), _c('v-list-item', {
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold"
  }, [_vm._v("\n                                    Jenis User\n                                ")]), _vm._v(" "), _c('v-radio-group', {
    attrs: {
      "row": ""
    },
    model: {
      value: (_vm.data.target_user),
      callback: function($$v) {
        _vm.$set(_vm.data, "target_user", $$v)
      },
      expression: "data.target_user"
    }
  }, [_c('v-radio', {
    staticClass: "radio-selection",
    attrs: {
      "id": "tema_user_student",
      "label": "Student",
      "value": "student",
      "active-class": "act-radio-btn"
    }
  }), _vm._v(" "), _c('v-radio', {
    staticClass: "radio-selection",
    attrs: {
      "id": "tema_user_teacher",
      "label": "Teacher",
      "value": "teacher",
      "active-class": "act-radio-btn"
    }
  }), _vm._v(" "), _c('v-radio', {
    staticClass: "radio-selection",
    attrs: {
      "id": "tema_user_parent",
      "label": "Parent",
      "value": "parent",
      "active-class": "act-radio-btn"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-list-item', {
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0 mt-3"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold"
  }, [_vm._v("\n                                    Tipe Soal\n                                ")]), _vm._v(" "), _c('v-radio-group', {
    attrs: {
      "row": ""
    },
    model: {
      value: (_vm.data.type),
      callback: function($$v) {
        _vm.$set(_vm.data, "type", $$v)
      },
      expression: "data.type"
    }
  }, [_c('v-radio', {
    staticClass: "radio-selection",
    attrs: {
      "id": "tema_type_tryout",
      "label": "Tryout",
      "value": "tryout",
      "active-class": "act-radio-btn"
    }
  }), _vm._v(" "), _c('v-radio', {
    staticClass: "radio-selection",
    attrs: {
      "id": "tema_type_non_tryout",
      "label": "Non Tryout",
      "value": "non_tryout",
      "active-class": "act-radio-btn"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', {
    staticClass: "pa-4"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "px-6 py-2 white--text",
    attrs: {
      "loading": _vm.isLoading,
      "id": "oss_config_android_banner_simpan",
      "depressed": "",
      "color": "blew"
    },
    on: {
      "click": function($event) {
        return _vm.upload()
      }
    }
  }, [_vm._v("Simpan")])], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9e9b2aa0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/ambis_test/components/ThemeForm.vue
// module id = 1419
// module chunks = 1